import React, { useEffect, useRef, useState } from "react";
import { Button, Stack, Tabs, TabList, Tab, TabPanels, TabPanel, ComboBox, DatePicker, DatePickerInput, Modal, Select, SelectItem, TextInput, Accordion, AccordionItem } from "@carbon/react";
import { DataTable as DataTableIcon, Identification, UpdateNow, Person, SummaryKpi, ChartRadar, ChartColumn, ListNumbered, Bee, UserFollow } from "@carbon/icons-react";
import Typography from "../../../components/Basics/Typography";
import Card from '../../../components/Layouts/Card';
import { CardRow, CardComponent } from "../../../components/Layouts/Card.styles";
import DriverDetails from "./DriverDetails.container";
import { useSelector, useDispatch } from 'react-redux';
import { onGetDriverThunk, onGetDriverLicenseThunk, onGetRankingThunk, onAddDriverThunk, onUpdateDriverThunk } from "./Driver.actions";
import LicenseEditModal from "./LicenseEditModal.container";
import ExpansionTable from "../../../components/Basics/ExpansionTable.container";
import SearchTable from "../../../components/Basics/SearchTable.container";
import LicenseUpdateModal from "./LicenseUpdateModal.container";
import { useSorting } from "../../../modules/hooks/sorting";
import LoadingContent from "../../../components/Animations/LoadingContent";
import ProgressBar from "../../../components/Graphs/ProgressBar.container";
import Radar from "../../../components/Graphs/Radar.container";
import AlertDashboard from "../../../components/Basics/Alertas.container";
import LineChartComponent from "../../../components/Graphs/Linealchart.container";
import CarbonTableComponent from "../../../components/Basics/Table.container";
import { spacing05 } from "@carbon/themes";
import { onGetAdasThunk, onGetPerdidasThunk, onGetFrenosThunk } from "./Driver.actions";

const DriverContainer = () => {
    const [selectedRut, setSelectedRut] = useState(null);
    const [selectedDriverName, setSelectedDriverName] = useState(null);
    const [selectedField, setSelectedField] = useState('tiempo_cambio_turno'); // Valor predeterminado
    const [selectedDriver, setSelectedDriver] = useState(null); // Almacena el objeto del conductor
    const [openLlaveroModal, setOpenLlaveroModal] = useState(false);
    const today_4 = new Date();
    const yesterday_4 = new Date(today_4);
    const date_4 = new Date(yesterday_4.setDate(yesterday_4.getDate() - 2));
    const maxDateString = date_4.toISOString().split('T')[0]; // Formato YYYY-MM-DD
    console.log(maxDateString, 'maxDateString');

    const [dateValue, setDateValue] = useState(date_4); // Estado para el DatePicker
    const [licenseExpiryDate, setLicenseExpiryDate] = useState(null);
    const parseDateLocal = (dateString) => {
        const [year, month, day] = dateString.split('-').map(Number);
        return new Date(year, month - 1, day); // OJO: en JS el mes empieza en 0 (enero = 0)
    };

    const items = [
        { label: 'Inicio de Turno Efectivo', value: 'tiempo_cambio_turno' },
        { label: 'Hora de Término Efectivo', value: 'tiempo_termino_turno' },
        { label: 'Duración de Colación', value: 'colacion_time' },
    ];
    // Encuentra el objeto correspondiente al valor seleccionado
    const selectedItem = items.find((item) => item.value === selectedField);

    const items_2 = [
        { label: 'Alerta de Velocidad + Retardador + Pisado de Frenos', value: 'Alerta de Velocidad + Retardador + Pisado de Frenos' },
        { label: 'Alerta de Velocidad + Retardador', value: 'Alerta de Velocidad + Retardador' },
        { label: 'Alerta exceso de Velocidad', value: 'Alerta exceso de Velocidad' },
        { label: 'Alerta de Velocidad + Frenos', value: 'Alerta de Velocidad + Frenos' },
        { label: 'Alerta, intensidad y periodicidad de frenado', value: 'Alerta, intensidad y periodicidad de frenado' },
        { label: 'Alerta Frenado + Retardador', value: 'Alerta Frenado + Retardador' },
        { label: 'Alerta Retardador Desactivado', value: 'Alerta Retardador Desactivado' },
    ];

    const [selectedOption, setSelectedOption] = useState(items[0]); // Valor inicial
    const [selectedOption_2, setSelectedOption_2] = useState(items_2[0]); // Valor inicial
    const [isNewDriverModalOpen, setIsNewDriverModalOpen] = useState(false);
    const [isEditDriverMode, setIsEditDriverMode] = useState(false);
    const [selectedDriverData, setSelectedDriverData] = useState(null);

    const [driverForm, setDriverForm] = useState({
        driverId: '',
        old_driverId: '', // NUEVO
        old_driverId_second: '', // NUEVO
        old_driverId_third: '', // NUEVO
        old_driverId_fourth: '', // NUEVO
        old_driverId_fifth: '', // NUEVO
        turn: '',
        truck: '',
        name: '',
        surname: '',
        rut: '',
        dv: '',
        phone: '',
        license_number: '',
        expiry: '',
    });

    const handleEditDriver = (rowId) => {
        const driverToEdit = rows_c.find(row => row.id === rowId);
        if (driverToEdit) {
            setDriverForm({
                driverId: driverToEdit.driverId || '',
                old_driverId: driverToEdit.old_driverId || '',
                old_driverId_second: driverToEdit.old_driverId_second || '',
                old_driverId_third: driverToEdit.old_driverId_third || '',
                old_driverId_fourth: driverToEdit.old_driverId_fourth || '',
                old_driverId_fifth: driverToEdit.old_driverId_fifth || '',
                turn: driverToEdit.turn || '',
                truck: driverToEdit.truck || '',
                name: driverToEdit.name || '',
                surname: driverToEdit.surname || '',
                rut: driverToEdit.rut || '',
                dv: driverToEdit.dv || '',
                phone: driverToEdit.phone || '',
                license_number: driverToEdit.license_number || '',
                expiry: driverToEdit.expiry || '',
            });
            setSelectedDriverData(driverToEdit);
            setIsEditDriverMode(true);
            setIsNewDriverModalOpen(true);
        }
    };

    const saveDriverChanges = (driverData) => {
        dispatch(onUpdateDriverThunk(driverData))
            .then(() => {
                dispatch(onGetDriverThunk()); // Volvemos a traer todos los conductores actualizados
                setIsNewDriverModalOpen(false); // Cerramos el modal
                setIsEditDriverMode(false); // Salimos de modo edición
                setSelectedDriverData(null); // Limpiamos conductor seleccionado
            })
            .catch(error => {
                console.error("Error al actualizar el conductor:", error);
            });
    };

    const createNewDriver = (driverData) => {
        dispatch(onAddDriverThunk(driverData))
            .then(() => {
                // Después de añadir exitosamente, recargamos la lista de conductores
                dispatch(onGetDriverThunk());
                setIsNewDriverModalOpen(false); // Cerramos el modal
            })
            .catch(error => {
                console.error("Error al crear el nuevo conductor:", error);
                // Puedes mostrar un mensaje de error si quieres
            });
    };

    const [conduccion, setConduccion] = useState([
        { title: 'Advertencia de colisión frontal', total: 0, promedio: 1 },
        { title: 'Advertencia de colisión peatonal', total: 0, promedio: 1 },
        { title: 'Advertencia de colisión vehículo', total: 0, promedio: 1 },
        { title: 'Alerta de distancia insuficiente', total: 0, promedio: 1 },
        { title: 'Poca visibilidad', total: 0, promedio: 1 },
        { title: 'Cámara bloqueada', total: 0, promedio: 1 },
    ]);

    const [fatiga, setFatiga] = useState([
        { title: 'Uso de celular', total: 0, promedio: 1 },
        { title: 'Conductor Fumando', total: 0, promedio: 1 },
        { title: 'Conductor distraído', total: 0, promedio: 1 },
        { title: 'Advertencia de fatiga', total: 0, promedio: 1 },
        { title: 'Alarma de fatiga', total: 0, promedio: 1 },
        { title: 'Foto fatiga', total: 0, promedio: 1 },
    ]);

    const [tableRows, setTableRows] = useState([
        { id: 'row-1', name: 'Inicio de Turno Efectivo', status: 0, example: 0.5 },
        { id: 'row-2', name: 'Hora de Término Efectivo', status: 0, example: 0.5 },
        { id: 'row-3', name: 'Duración de Colación', status: 0, example: 1 },
    ]);

    const [tableRows_2, setTableRows_2] = useState([
        { id: 'row-1', name: 'Alerta de Velocidad + Retardador + Pisado de Frenos', status: 0, example: 5 },
        { id: 'row-2', name: 'Alerta de Velocidad + Retardador', status: 0, example: 5 },
        { id: 'row-3', name: 'Alerta exceso de Velocidad', status: 0, example: 5 },
        { id: 'row-4', name: 'Alerta de Velocidad + Frenos', status: 0, example: 5 },
        { id: 'row-5', name: 'Alerta, intensidad y periodicidad de frenado', status: 0, example: 5 },
        { id: 'row-6', name: 'Alerta Frenado + Retardador', status: 0, example: 5 },
        { id: 'row-7', name: 'Alerta Retardador Desactivado', status: 0, example: 5 },
    ]);

    const [perdidasSemana, setPerdidasSemana] = useState([
        { "group": "Dataset 1", "date": "2024-04-19", "value": 0 },
        { "group": "Dataset 1", "date": "2024-04-20", "value": 0 },
        { "group": "Dataset 1", "date": "2024-04-21", "value": 0 },
        { "group": "Dataset 1", "date": "2024-04-22", "value": 0 },
        { "group": "Dataset 1", "date": "2024-04-23", "value": 0 },
        { "group": "Dataset 1", "date": "2024-04-24", "value": 0 },
        { "group": "Dataset 1", "date": "2024-04-25", "value": 0 },
    ]);

    const [frenosSemana, setFrenosSemana] = useState([
        { "group": "Dataset 1", "date": "2024-04-19", "value": 0 },
        { "group": "Dataset 1", "date": "2024-04-20", "value": 0 },
        { "group": "Dataset 1", "date": "2024-04-21", "value": 0 },
        { "group": "Dataset 1", "date": "2024-04-22", "value": 0 },
        { "group": "Dataset 1", "date": "2024-04-23", "value": 0 },
        { "group": "Dataset 1", "date": "2024-04-24", "value": 0 },
        { "group": "Dataset 1", "date": "2024-04-25", "value": 0 },
    ]);

    const [radarData_2, setRadarData_2] = useState([
        {
            "product": "Conductor",
            "feature": "Alerta de Velocidad + Retardador + Pisado de Frenos",
            "score": 0
        },
        {
            "product": "Conductor",
            "feature": "Alerta de Velocidad + Retardador",
            "score": 0
        },
        {
            "product": "Conductor",
            "feature": "Alerta exceso de Velocidad",
            "score": 0
        },
        {
            "product": "Conductor",
            "feature": "Alerta de Velocidad + Frenos",
            "score": 0
        },
        {
            "product": "Conductor",
            "feature": "Alerta, intensidad y periodicidad de frenado",
            "score": 0
        },
        {
            "product": "Conductor",
            "feature": "Alerta Frenado + Retardador",
            "score": 0
        },
        {
            "product": "Conductor",
            "feature": "Alerta Retardador Desactivado",
            "score": 0
        },
        {
            "product": "Rendimiento Optimo",
            "feature": "Alerta de Velocidad + Retardador + Pisado de Frenos",
            "score": 5
        },
        {
            "product": "Rendimiento Optimo",
            "feature": "Alerta de Velocidad + Retardador",
            "score": 5
        },
        {
            "product": "Rendimiento Optimo",
            "feature": "Alerta exceso de Velocidad",
            "score": 5
        },
        {
            "product": "Rendimiento Optimo",
            "feature": "Alerta de Velocidad + Frenos",
            "score": 5
        },
        {
            "product": "Rendimiento Optimo",
            "feature": "Alerta, intensidad y periodicidad de frenado",
            "score": 5
        },
        {
            "product": "Rendimiento Optimo",
            "feature": "Alerta Frenado + Retardador",
            "score": 5
        },
        {
            "product": "Rendimiento Optimo",
            "feature": "Alerta Retardador Desactivado",
            "score": 5
        }
    ]);

    const [radarData, setRadarData] = useState([
        {
            "product": "Conductor",
            "feature": "Inicio de Turno",
            "score": 0
        },
        {
            "product": "Conductor",
            "feature": "Término de Turno",
            "score": 0
        },
        {
            "product": "Conductor",
            "feature": "Colación",
            "score": 0
        },
        {
            "product": "Rendimiento Optimo",
            "feature": "Inicio de Turno",
            "score": 0.5
        },
        {
            "product": "Rendimiento Optimo",
            "feature": "Término de Turno",
            "score": 0.5
        },
        {
            "product": "Rendimiento Optimo",
            "feature": "Colación",
            "score": 1
        }
    ]);

    const buttonRef = useRef(null);
    const [openLicenseEditModal, setOpenLicenseEditModal] = useState(false);
    const buttonUpdateRef = useRef(null);
    const [openLicenseUpdateModal, setOpenLicenseUpdateModal] = useState(null);

    const driverDetailsButtonRef = useRef();
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch()
    const { error_data, loading_data, loading_adas, error_perdidas, loading_perdidas, error_frenos, loading_frenos, data, perdidas, frenos, perdidas_semana, perdidas_ranking, frenos_semana, loading_ranking, error_ranking, ranking } = useSelector(state => state.driver)

    useEffect(() => {
        if (!loading_data) {
            return
        }
        dispatch(onGetDriverThunk())
    }, [loading_data, dispatch])

    useEffect(() => {
        if (perdidas && typeof perdidas === 'object' && !error_perdidas && perdidas['0']) {
            const updatedTableRows = [
                { id: 'row-1', name: 'Inicio de Turno Efectivo', status: perdidas['0'].tiempo_cambio_turno || 0, example: 0.5 },
                { id: 'row-2', name: 'Hora de Término Efectivo', status: perdidas['0'].tiempo_termino_turno || 0, example: 0.5 },
                { id: 'row-3', name: 'Duración de Colación', status: perdidas['0'].colacion_time || 0, example: 1 },
            ];
            setTableRows(updatedTableRows);

            const formattedSemanaData = perdidas_semana.map((item, index) => {
                const fecha = new Date(dateValue);
                fecha.setDate(fecha.getDate() - (index)); // Resta días dinámicamente
                console.log(fecha.toISOString());

                return {
                    group: "Dataset 1",
                    date: fecha.toISOString(), // Formatea la fecha como YYYY-MM-DD
                    value: item[selectedOption.value] || 0,
                };
            });

            setPerdidasSemana(formattedSemanaData);

            const updatedRadarData = radarData.map(data => {
                if (data.product === "Conductor") {
                    let score = 0;
                    switch (data.feature) {
                        case "Inicio de Turno":
                            score = perdidas['0'].tiempo_cambio_turno || 0;
                            break;
                        case "Término de Turno":
                            score = perdidas['0'].tiempo_termino_turno || 0;
                            break;
                        case "Colación":
                            score = perdidas['0'].colacion_time || 0;
                            break;
                        default:
                            score = 0;
                    }
                    return {
                        ...data,
                        product: "Conductor",
                        score: score
                    };
                }
                return data;
            });
            setRadarData(updatedRadarData);
        } else {
            setTableRows([
                { id: 'row-1', name: 'Inicio de Turno Efectivo', status: 0, example: 0.5 },
                { id: 'row-2', name: 'Hora de Término Efectivo', status: 0, example: 0.5 },
                { id: 'row-3', name: 'Duración de Colación', status: 0, example: 1 },
            ]);

            setPerdidasSemana([
                { "group": "Dataset 1", "date": "2024-04-19", "value": 0 },
                { "group": "Dataset 1", "date": "2024-04-20", "value": 0 },
                { "group": "Dataset 1", "date": "2024-04-21", "value": 0 },
                { "group": "Dataset 1", "date": "2024-04-22", "value": 0 },
                { "group": "Dataset 1", "date": "2024-04-23", "value": 0 },
                { "group": "Dataset 1", "date": "2024-04-24", "value": 0 },
                { "group": "Dataset 1", "date": "2024-04-25", "value": 0 },
            ]);

            setRadarData([
                {
                    "product": "Conductor",
                    "feature": "Inicio de Turno",
                    "score": 0
                },
                {
                    "product": "Conductor",
                    "feature": "Término de Turno",
                    "score": 0
                },
                {
                    "product": "Conductor",
                    "feature": "Colación",
                    "score": 0
                },
                {
                    "product": "Rendimiento Optimo",
                    "feature": "Inicio de Turno",
                    "score": 0.5
                },
                {
                    "product": "Rendimiento Optimo",
                    "feature": "Término de Turno",
                    "score": 0.5
                },
                {
                    "product": "Rendimiento Optimo",
                    "feature": "Colación",
                    "score": 1
                }
            ]);
        }
    }, [perdidas, selectedDriverName, error_perdidas, selectedOption]);

    useEffect(() => {
        if (frenos && typeof frenos === 'object' && !error_frenos && frenos['0']) {
            const updatedTableRows_2 = tableRows_2.map((row) => {
                const matchingData = Object.values(frenos).find(freno => freno.plan_marcha === row.name);
                if (matchingData) {
                    return {
                        ...row,
                        status: matchingData.count || 0, // Cambié 'status' a 'count' para reflejar los datos correctos
                    };
                }
                return row;
            });
            setTableRows_2(updatedTableRows_2);

            const formattedSemanaData = frenos_semana.map((item) => {

                const frenoData = item.datos.find(
                    (freno) => freno.plan_marcha === selectedOption_2.value
                );

                const fecha = new Date(item.fecha);
                fecha.setHours(fecha.getHours() + 5);
                const fechaISO = fecha.toISOString();

                return {
                    group: "Dataset 1",
                    date: fechaISO, // Fecha en formato YYYY-MM-DD
                    value: frenoData ? frenoData.count : 0, // Toma el valor de count o 0 si no existe
                };
            });

            // Actualiza el estado con los datos formateados
            setFrenosSemana(formattedSemanaData);

            // Actualizamos radarData_2
            const updatedRadarData_2 = radarData_2.map((data) => {
                // Solo actualizamos si el producto es "Conductor"
                if (data.product === "Conductor") {
                    const matchingData = Object.values(frenos).find(
                        (freno) => freno.plan_marcha === data.feature
                    );
                    if (matchingData) {
                        return {
                            ...data,
                            score: matchingData.count || 0,
                        };
                    }
                }
                // Si no es "Conductor", devolvemos el objeto tal como está
                return data;
            });
            setRadarData_2(updatedRadarData_2);

        } else {
            setTableRows_2([
                { id: 'row-1', name: 'Alerta de Velocidad + Retardador + Pisado de Frenos', status: 0, example: 5 },
                { id: 'row-2', name: 'Alerta de Velocidad + Retardador', status: 0, example: 5 },
                { id: 'row-3', name: 'Alerta exceso de Velocidad', status: 0, example: 5 },
                { id: 'row-4', name: 'Alerta de Velocidad + Frenos', status: 0, example: 5 },
                { id: 'row-5', name: 'Alerta, intensidad y periodicidad de frenado', status: 0, example: 5 },
                { id: 'row-6', name: 'Alerta Frenado + Retardador', status: 0, example: 5 },
                { id: 'row-7', name: 'Alerta Retardador Desactivado', status: 0, example: 5 },
            ]);
            setPerdidasSemana([
                { "group": "Dataset 1", "date": "2024-04-19", "value": 0 },
                { "group": "Dataset 1", "date": "2024-04-20", "value": 0 },
                { "group": "Dataset 1", "date": "2024-04-21", "value": 0 },
                { "group": "Dataset 1", "date": "2024-04-22", "value": 0 },
                { "group": "Dataset 1", "date": "2024-04-23", "value": 0 },
                { "group": "Dataset 1", "date": "2024-04-24", "value": 0 },
                { "group": "Dataset 1", "date": "2024-04-25", "value": 0 },
            ]);
            setRadarData_2([
                {
                    "product": "Conductor",
                    "feature": "Alerta de Velocidad + Retardador + Pisado de Frenos",
                    "score": 0
                },
                {
                    "product": "Conductor",
                    "feature": "Alerta de Velocidad + Retardador",
                    "score": 0
                },
                {
                    "product": "Conductor",
                    "feature": "Alerta exceso de Velocidad",
                    "score": 0
                },
                {
                    "product": "Conductor",
                    "feature": "Alerta de Velocidad + Frenos",
                    "score": 0
                },
                {
                    "product": "Conductor",
                    "feature": "Alerta, intensidad y periodicidad de frenado",
                    "score": 0
                },
                {
                    "product": "Conductor",
                    "feature": "Alerta Frenado + Retardador",
                    "score": 0
                },
                {
                    "product": "Conductor",
                    "feature": "Alerta Retardador Desactivado",
                    "score": 0
                },
                {
                    "product": "Rendimiento Optimo",
                    "feature": "Alerta de Velocidad + Retardador + Pisado de Frenos",
                    "score": 5
                },
                {
                    "product": "Rendimiento Optimo",
                    "feature": "Alerta de Velocidad + Retardador",
                    "score": 5
                },
                {
                    "product": "Rendimiento Optimo",
                    "feature": "Alerta exceso de Velocidad",
                    "score": 5
                },
                {
                    "product": "Rendimiento Optimo",
                    "feature": "Alerta de Velocidad + Frenos",
                    "score": 5
                },
                {
                    "product": "Rendimiento Optimo",
                    "feature": "Alerta, intensidad y periodicidad de frenado",
                    "score": 5
                },
                {
                    "product": "Rendimiento Optimo",
                    "feature": "Alerta Frenado + Retardador",
                    "score": 5
                },
                {
                    "product": "Rendimiento Optimo",
                    "feature": "Alerta Retardador Desactivado",
                    "score": 5
                }
            ]);
        }
    }, [frenos, selectedDriverName, error_frenos, selectedOption_2]);

    const updateAlertData = (adasData) => {
        if (adasData && adasData.adas && Array.isArray(adasData.adas)) {
            setFatiga((prevFatiga) => {
                const updatedFatiga = prevFatiga.map((item) => {
                    const matchingData = adasData.adas.find((ada) => {
                        switch (ada.label) {
                            case 'ftgphone':
                                return item.title === 'Uso de celular';
                            case 'ftgsmoking':
                                return item.title === 'Conductor Fumando';
                            case 'ftgdistrct':
                                return item.title === 'Conductor distraído';
                            case 'ftgwarning':
                                return item.title === 'Advertencia de fatiga';
                            case 'ftgalarm':
                                return item.title === 'Alarma de fatiga';
                            case 'ftgphoto':
                                return item.title === 'Foto fatiga';
                            default:
                                return false;
                        }
                    });

                    if (matchingData) {
                        return { ...item, total: matchingData.count };
                    }
                    return item;
                });
                return updatedFatiga;
            });

            setConduccion((prevConduccion) => {
                const updatedConduccion = prevConduccion.map((item) => {
                    const matchingData = adasData.adas.find((ada) => {
                        switch (ada.label) {
                            case 'mdas9acf':
                                return item.title === 'Advertencia de colisión frontal';
                            case 'mdas9acp':
                                return item.title === 'Advertencia de colisión peatonal';
                            case 'mdas9acv':
                                return item.title === 'Advertencia de colisión vehículo';
                            case 'mdas9ccf2s':
                                return item.title === 'Alerta de distancia insuficiente';
                            case 'mdas9pv':
                                return item.title === 'Poca visibilidad';
                            case 'camblck':
                                return item.title === 'Cámara bloqueada';
                            default:
                                return false;
                        }
                    });

                    if (matchingData) {
                        return { ...item, total: matchingData.count };
                    }
                    return item;
                });
                return updatedConduccion;
            });
        } else {
            console.warn("No se encontraron datos válidos de ADAS para actualizar.");
        }
    };

    const handleDriverChange = (selectedDriver, customDate = null) => {
        const driver = driverNames.find(driver => driver.name === selectedDriver);
        if (driver) {
            setSelectedDriver(driver);
            setSelectedRut(driver.rut);
            setSelectedDriverName(driver.name);
            setSelectedOption(items[0])
            console.log('entra al driver');

            // Reset conduccion, fatiga, tableRows, and radarData to initial state
            setConduccion([
                { title: 'Advertencia de colisión frontal', total: 0, promedio: 1 },
                { title: 'Advertencia de colisión peatonal', total: 0, promedio: 1 },
                { title: 'Advertencia de colisión vehículo', total: 0, promedio: 1 },
                { title: 'Alerta de distancia insuficiente', total: 0, promedio: 1 },
                { title: 'Poca visibilidad', total: 0, promedio: 1 },
                { title: 'Cámara bloqueada', total: 0, promedio: 1 },
            ]);

            setFatiga([
                { title: 'Uso de celular', total: 0, promedio: 1 },
                { title: 'Conductor Fumando', total: 0, promedio: 1 },
                { title: 'Conductor distraído', total: 0, promedio: 1 },
                { title: 'Advertencia de fatiga', total: 0, promedio: 1 },
                { title: 'Alarma de fatiga', total: 0, promedio: 1 },
                { title: 'Foto fatiga', total: 0, promedio: 1 },
            ]);

            setTableRows([
                { id: 'row-1', name: 'Inicio de Turno Efectivo', status: 0, example: 0.5 },
                { id: 'row-2', name: 'Hora de Término Efectivo', status: 0, example: 0.5 },
                { id: 'row-3', name: 'Duración de Colación', status: 0, example: 1 },
            ]);

            setPerdidasSemana([
                { "group": "Dataset 1", "date": "2024-04-19", "value": 0 },
                { "group": "Dataset 1", "date": "2024-04-20", "value": 0 },
                { "group": "Dataset 1", "date": "2024-04-21", "value": 0 },
                { "group": "Dataset 1", "date": "2024-04-22", "value": 0 },
                { "group": "Dataset 1", "date": "2024-04-23", "value": 0 },
                { "group": "Dataset 1", "date": "2024-04-24", "value": 0 },
                { "group": "Dataset 1", "date": "2024-04-25", "value": 0 },
            ]);

            setTableRows_2([
                { id: 'row-1', name: 'Alerta de Velocidad + Retardador + Pisado de Frenos', status: 0, example: 5 },
                { id: 'row-2', name: 'Alerta de Velocidad + Retardador', status: 0, example: 5 },
                { id: 'row-3', name: 'Alerta exceso de Velocidad', status: 0, example: 5 },
                { id: 'row-4', name: 'Alerta de Velocidad + Frenos', status: 0, example: 5 },
                { id: 'row-5', name: 'Alerta, intensidad y periodicidad de frenado', status: 0, example: 5 },
                { id: 'row-6', name: 'Alerta Frenado + Retardador', status: 0, example: 5 },
                { id: 'row-7', name: 'Alerta Retardador Desactivado', status: 0, example: 5 },
            ]);

            setPerdidasSemana([
                { "group": "Dataset 1", "date": "2024-04-19", "value": 0 },
                { "group": "Dataset 1", "date": "2024-04-20", "value": 0 },
                { "group": "Dataset 1", "date": "2024-04-21", "value": 0 },
                { "group": "Dataset 1", "date": "2024-04-22", "value": 0 },
                { "group": "Dataset 1", "date": "2024-04-23", "value": 0 },
                { "group": "Dataset 1", "date": "2024-04-24", "value": 0 },
                { "group": "Dataset 1", "date": "2024-04-25", "value": 0 },
            ]);

            setRadarData([
                {
                    "product": "Conductor",
                    "feature": "Inicio de Turno",
                    "score": 0
                },
                {
                    "product": "Conductor",
                    "feature": "Término de Turno",
                    "score": 0
                },
                {
                    "product": "Conductor",
                    "feature": "Colación",
                    "score": 0
                },
                {
                    "product": "Rendimiento Optimo",
                    "feature": "Inicio de Turno",
                    "score": 0.5
                },
                {
                    "product": "Rendimiento Optimo",
                    "feature": "Término de Turno",
                    "score": 0.5
                },
                {
                    "product": "Rendimiento Optimo",
                    "feature": "Colación",
                    "score": 1
                }
            ]);

            setRadarData_2([
                {
                    "product": "Conductor",
                    "feature": "Alerta de Velocidad + Retardador + Pisado de Frenos",
                    "score": 0
                },
                {
                    "product": "Conductor",
                    "feature": "Alerta de Velocidad + Retardador",
                    "score": 0
                },
                {
                    "product": "Conductor",
                    "feature": "Alerta exceso de Velocidad",
                    "score": 0
                },
                {
                    "product": "Conductor",
                    "feature": "Alerta de Velocidad + Frenos",
                    "score": 0
                },
                {
                    "product": "Conductor",
                    "feature": "Alerta, intensidad y periodicidad de frenado",
                    "score": 0
                },
                {
                    "product": "Conductor",
                    "feature": "Alerta Frenado + Retardador",
                    "score": 0
                },
                {
                    "product": "Conductor",
                    "feature": "Alerta Retardador Desactivado",
                    "score": 0
                },
                {
                    "product": "Rendimiento Optimo",
                    "feature": "Alerta de Velocidad + Retardador + Pisado de Frenos",
                    "score": 5
                },
                {
                    "product": "Rendimiento Optimo",
                    "feature": "Alerta de Velocidad + Retardador",
                    "score": 5
                },
                {
                    "product": "Rendimiento Optimo",
                    "feature": "Alerta exceso de Velocidad",
                    "score": 5
                },
                {
                    "product": "Rendimiento Optimo",
                    "feature": "Alerta de Velocidad + Frenos",
                    "score": 5
                },
                {
                    "product": "Rendimiento Optimo",
                    "feature": "Alerta, intensidad y periodicidad de frenado",
                    "score": 5
                },
                {
                    "product": "Rendimiento Optimo",
                    "feature": "Alerta Frenado + Retardador",
                    "score": 5
                },
                {
                    "product": "Rendimiento Optimo",
                    "feature": "Alerta Retardador Desactivado",
                    "score": 5
                }
            ]);

            // Parámetros predefinidos
            const date = customDate || dateValue;
            console.log(date, 'fecha al fetch');
            console.log(dateValue, 'valor dentro del driver change');

            let turno = 'TURNO DIA';

            // Llamar a las funciones con los parámetros adecuados
            const fetchData = () => {
                return Promise.all([
                    dispatch(onGetAdasThunk(date, turno, driver.rut)).catch(error => ({ error })),
                    dispatch(onGetPerdidasThunk(date, turno, driver.rut)).catch(error => ({ error })),
                    dispatch(onGetFrenosThunk(date, turno, driver.rut)).catch(error => ({ error }))
                ]);
            };

            fetchData().then(([adasResponse, perdidasResponse, frenosResponse]) => {
                const allFailed = [adasResponse, perdidasResponse, frenosResponse].every(response => response.payload && response.payload.error);
                if (allFailed) {
                    console.error("All requests failed with TURNO DIA, retrying with TURNO NOCHE");
                    turno = 'TURNO NOCHE';
                    fetchData().then(([adasResponse, perdidasResponse, frenosResponse]) => {
                        if (!adasResponse.error && adasResponse.payload && adasResponse.payload.adas['0']) {
                            updateAlertData(adasResponse.payload);
                        }
                        if (!perdidasResponse.error && perdidasResponse.payload && perdidasResponse.payload['0']) {
                            const updatedTableRows = [
                                { id: 'row-1', name: 'Inicio de Turno Efectivo', status: perdidasResponse.payload['0'].tiempo_cambio_turno || 0, example: 0.5 },
                                { id: 'row-2', name: 'Hora de Término Efectivo', status: perdidasResponse.payload['0'].tiempo_termino_turno || 0, example: 0.5 },
                                { id: 'row-3', name: 'Duración de Colación', status: perdidasResponse.payload['0'].colacion_time || 0, example: 1 },
                            ];
                            setTableRows(updatedTableRows);

                            const formattedSemanaData = perdidas_semana.map((item, index) => {
                                const fecha = dateValue;
                                fecha.setDate(fecha.getDate() - (index)); // Resta días dinámicamente

                                return {
                                    group: "Dataset 1",
                                    date: fecha.toISOString(), // Formatea la fecha como YYYY-MM-DD
                                    value: item[selectedOption.value] || 0,
                                };
                            });
                            setPerdidasSemana(formattedSemanaData);

                            const updatedRadarData = radarData.map(data => {
                                if (data.product === "Conductor") {
                                    let score = 0;
                                    switch (data.feature) {
                                        case "Inicio de Turno":
                                            score = perdidasResponse.payload['0'].tiempo_cambio_turno || 0;
                                            break;
                                        case "Término de Turno":
                                            score = perdidasResponse.payload['0'].tiempo_termino_turno || 0;
                                            break;
                                        case "Colación":
                                            score = perdidasResponse.payload['0'].colacion_time || 0;
                                            break;
                                        default:
                                            score = 0;
                                    }
                                    return {
                                        ...data,
                                        product: "Conductor",
                                        score: score
                                    };
                                }
                                return data;
                            });
                            setRadarData(updatedRadarData);
                        }
                        if (!frenosResponse.error && frenosResponse.payload && frenosResponse.payload['0']) {
                            const updatedTableRows_2 = tableRows_2.map((row) => {
                                const matchingData = Object.values(frenos).find(freno => freno.plan_marcha === row.name);
                                if (matchingData) {
                                    return {
                                        ...row,
                                        status: matchingData.count || 0, // Cambié 'status' a 'count' para reflejar los datos correctos
                                    };
                                }
                                return row;
                            });
                            setTableRows_2(updatedTableRows_2);

                            const formattedSemanaData = frenos_semana.map((item) => {

                                const frenoData = item.datos.find(
                                    (freno) => freno.plan_marcha === selectedOption_2.value
                                );

                                const fecha = new Date(item.fecha);
                                fecha.setHours(fecha.getHours() + 5);
                                const fechaISO = fecha.toISOString();

                                return {
                                    group: "Dataset 1",
                                    date: fechaISO, // Fecha en formato YYYY-MM-DD
                                    value: frenoData ? frenoData.count : 0, // Toma el valor de count o 0 si no existe
                                };
                            });
                            setFrenosSemana(formattedSemanaData);

                            const updatedRadarData_2 = radarData_2.map((data) => {
                                // Solo actualizamos si el producto es "Conductor"
                                if (data.product === "Conductor") {
                                    const matchingData = Object.values(frenos).find(
                                        (freno) => freno.plan_marcha === data.feature
                                    );

                                    if (matchingData) {
                                        return {
                                            ...data,
                                            score: matchingData.count || 0,
                                        };
                                    }
                                }
                                // Si no es "Conductor", devolvemos el objeto tal como está
                                return data;
                            });
                            setRadarData_2(updatedRadarData_2);
                        }
                    }).catch(error => {
                        console.error("Error fetching data with TURNO NOCHE: ", error);
                    });
                } else {
                    if (!adasResponse.error && adasResponse.payload && adasResponse.payload.adas['0']) {
                        updateAlertData(adasResponse.payload);
                    }
                    if (!perdidasResponse.error && perdidasResponse.payload && perdidasResponse.payload['0']) {
                        const updatedTableRows = [
                            { id: 'row-1', name: 'Inicio de Turno Efectivo', status: perdidasResponse.payload['0'].tiempo_cambio_turno || 0, example: 0.5 },
                            { id: 'row-2', name: 'Hora de Término Efectivo', status: perdidasResponse.payload['0'].tiempo_termino_turno || 0, example: 0.5 },
                            { id: 'row-3', name: 'Duración de Colación', status: perdidasResponse.payload['0'].colacion_time || 0, example: 1 },
                        ];
                        setTableRows(updatedTableRows);

                        const formattedSemanaData = perdidas_semana.map((item, index) => {
                            const fecha = dateValue;
                            fecha.setDate(fecha.getDate() - (index)); // Resta días dinámicamente

                            return {
                                group: "Dataset 1",
                                date: fecha.toISOString(), // Formatea la fecha como YYYY-MM-DD
                                value: item[selectedOption.value] || 0,
                            };
                        });
                        setPerdidasSemana(formattedSemanaData);

                        const updatedRadarData = radarData.map(data => {
                            if (data.product === "Conductor") {
                                let score = 0;
                                switch (data.feature) {
                                    case "Inicio de Turno":
                                        score = perdidasResponse.payload['0'].tiempo_cambio_turno || 0;
                                        break;
                                    case "Término de Turno":
                                        score = perdidasResponse.payload['0'].tiempo_termino_turno || 0;
                                        break;
                                    case "Colación":
                                        score = perdidasResponse.payload['0'].colacion_time || 0;
                                        break;
                                    default:
                                        score = 0;
                                }
                                return {
                                    ...data,
                                    product: "Conductor",
                                    score: score
                                };
                            }
                            return data;
                        });
                        setRadarData(updatedRadarData);
                    }
                    if (!frenosResponse.error && frenosResponse.payload && frenosResponse.payload['0']) {
                        const updatedTableRows_2 = tableRows_2.map((row) => {
                            const matchingData = Object.values(frenos).find(freno => freno.plan_marcha === row.name);
                            if (matchingData) {
                                return {
                                    ...row,
                                    status: matchingData.count || 0, // Cambié 'status' a 'count' para reflejar los datos correctos
                                };
                            }
                            return row;
                        });
                        setTableRows_2(updatedTableRows_2);

                        const formattedSemanaData = frenos_semana.map((item) => {

                            const frenoData = item.datos.find(
                                (freno) => freno.plan_marcha === selectedOption_2.value
                            );

                            const fecha = new Date(item.fecha);
                            fecha.setHours(fecha.getHours() + 5);
                            const fechaISO = fecha.toISOString();

                            return {
                                group: "Dataset 1",
                                date: fechaISO, // Fecha en formato YYYY-MM-DD
                                value: frenoData ? frenoData.count : 0, // Toma el valor de count o 0 si no existe
                            };
                        });
                        setFrenosSemana(formattedSemanaData);

                        const updatedRadarData_2 = radarData_2.map((data) => {
                            // Solo actualizamos si el producto es "Conductor"
                            if (data.product === "Conductor") {
                                const matchingData = Object.values(frenos).find(
                                    (freno) => freno.plan_marcha === data.feature
                                );

                                if (matchingData) {
                                    return {
                                        ...data,
                                        score: matchingData.count || 0,
                                    };
                                }
                            }
                            // Si no es "Conductor", devolvemos el objeto tal como está
                            return data;
                        });
                        setRadarData_2(updatedRadarData_2);
                    }
                }
            }).catch(error => {
                console.error("Error fetching data with TURNO DIA: ", error);
            });
        }
    };

    const formRefs = {
        driverId: useRef(),
        old_driverId: useRef(),
        old_driverId_second: useRef(),
        old_driverId_third: useRef(),
        old_driverId_fourth: useRef(),
        old_driverId_fifth: useRef(),
        name: useRef(),
        surname: useRef(),
        rut: useRef(),
        dv: useRef(),
        phone: useRef(),
        license_number: useRef(),
        expiry: useRef(),
        turn: useRef(),
        truck: useRef(),
    };

    const handleSubmitDriver = () => {
        const updatedData = {
            driverId: formRefs.driverId.current.value,
            name: formRefs.name.current.value,
            surname: formRefs.surname.current.value,
            rut: formRefs.rut.current.value,
            dv: formRefs.dv.current.value
        };

        const validationErrors = validateDriverForm(updatedData);
        if (validationErrors.length > 0) {
            alert("Errores en el formulario:\n- " + validationErrors.join("\n- "));
            return;
        }

        if (isEditDriverMode) {
            console.log("Guardar cambios", updatedData);
            saveDriverChanges(updatedData);
        } else {
            console.log("Crear nuevo conductor", updatedData);
            createNewDriver(updatedData);
        }

        // Cerrar el modal después de guardar
        setIsNewDriverModalOpen(false);
    };

    const headerData = [
        {
            header: 'Nombre',
            key: 'fullName',
            sortDirection: "ASC",
        },
        {
            header: 'Rut',
            key: 'fullRut',
        },
        {
            header: 'Estado de licencia',
            key: 'isExpired',
        },
        {
            header: 'Fecha Expiración',
            key: 'expiry',
            sortDirection: "DESC",
            isDefaultSortable: true
        },
        {
            header: 'Activo',
            key: 'isActive',
        },
        {
            header: 'ID llavero',  // Nueva columna
            key: 'driverId',
        }
    ];

    const headerData_c = [
        {
            header: 'Llave iButton',
            key: 'driverId',
        },
        // {
        //     header: 'Llave iButton (2)',
        //     key: 'old_driverId',
        // },
        // {
        //     header: 'Llave iButton (3)',
        //     key: 'old_driverId_second',
        // },
        {
            header: 'Nombre',
            key: 'name',
        },
        {
            header: 'Apellido',
            key: 'surname',
        },
        // {
        //     header: 'Rut',
        //     key: 'rut',
        // },
        // {
        //     header: 'Dv',
        //     key: 'dv',
        // },
        // {
        //     header: 'Celular',
        //     key: 'phone',
        // },
        // {
        //     header: 'Nº de licencia',
        //     key: 'license_number',
        // },
        // {
        //     header: 'Fecha Expiración',
        //     key: 'expiry',
        //     sortDirection: "DESC",
        //     isDefaultSortable: true
        // },
        // {
        //     header: 'Foto de licencia',
        //     key: 'photo',
        // },
        // {
        //     header: 'Activo/Inactivo',
        //     key: 'isActive',
        // },
        {
            header: 'Rut',
            key: 'rut',
        },
        {
            header: 'Digito verificador',
            key: 'dv',
        }
    ];

    const { rows: rows_c, headers: headers_c } = useSorting(data, headerData_c);
    const { rows: rows, headers: headers } = useSorting(data, headerData);

    const driverNames = data ? data.map(driver => ({ name: driver.fullName, rut: driver.rut })) : [];

    const handleTabClick = (tabName) => {
        if (tabName === 'ranking') {
            dispatch(onGetRankingThunk())
        }
    };

    const handleDateChange = (eventOrDates) => {
        console.log(eventOrDates, 'fecha que entra');

        if (!selectedDriver) {
            console.warn("Por favor selecciona un conductor antes de elegir una fecha.");
            return; // No hace nada si no hay un conductor seleccionado
        }

        if (Array.isArray(eventOrDates) && eventOrDates.length > 0) {
            console.log("entra al if 1");

            const selectedDate = eventOrDates[0];
            if (selectedDate instanceof Date && !isNaN(selectedDate)) {
                console.log("entra al if 2");
                setDateValue(selectedDate);
                console.log(dateValue, 'valor dentro del date change');

                console.log("selectedDriver?.name:", selectedDriver?.name);
                handleDriverChange(selectedDriver?.name, selectedDate);
            }
        }
    };

    const validateDriverForm = (data) => {
        const errors = [];

        // Validar driverId (iButton)
        if (!/^[a-z0-9]{16,16}$/.test(data.driverId)) {
            errors.push("La llave iButton debe tener 16 caracteres, solo letras minúsculas o números.");
        }

        // Validar nombre y apellido
        const nameRegex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{1,80}$/;
        if (!nameRegex.test(data.name)) {
            errors.push("El nombre debe tener hasta 80 caracteres y solo letras, espacios y tildes.");
        }
        if (!nameRegex.test(data.surname)) {
            errors.push("El apellido debe tener hasta 80 caracteres y solo letras, espacios y tildes.");
        }

        // Validar rut (letras mayúsculas y números, máximo 9)
        if (!/^[A-Z0-9]{7,9}$/.test(data.rut)) {
            errors.push("El RUT debe contener hasta 9 caracteres, solo letras mayúsculas y números.");
        }

        // Validar dv (no obligatorio, pero si existe solo 1 carácter alfanumérico)
        if (data.dv && !/^[A-Z0-9]$/.test(data.dv)) {
            errors.push("El dígito verificador debe ser 1 carácter.");
        }

        return errors;
    };

    useEffect(() => {
        if (isNewDriverModalOpen && !isEditDriverMode) {
            // Limpiar campos manualmente
            Object.values(formRefs).forEach(ref => {
                if (ref.current) ref.current.value = '';
            });
        }

        if (isNewDriverModalOpen && isEditDriverMode && selectedDriverData) {
            // Cargar datos al editar
            Object.entries(formRefs).forEach(([key, ref]) => {
                if (key === 'expiry' && selectedDriverData[key]) {
                    setLicenseExpiryDate(parseDateLocal(selectedDriverData[key]));
                } else if (ref.current && selectedDriverData[key] !== undefined) {
                    ref.current.value = selectedDriverData[key];
                }
            });
        }
    }, [isNewDriverModalOpen, isEditDriverMode, selectedDriverData]);

    return (
        <>
            {(!error_data) && (loading_data) && (
                <LoadingContent />
            )}
            {!loading_data && error_data && (
                <CardComponent width="10%">
                    <Typography className='cds--type-heading-compact-01'>
                        No hay registros de conductores
                    </Typography>
                </CardComponent>
            )}
            {!(loading_data) && !error_data && (
                <>
                    <Tabs>
                        <TabList activation="manual" aria-label="List of tabs">
                            <Tab renderIcon={Bee}>Gestion de Conductores y Llaveros</Tab>
                            <Tab renderIcon={Identification}>Gestion de Licencias</Tab>
                            <Tab renderIcon={ListNumbered} onClick={() => handleTabClick('ranking')}>Ranking Conductores</Tab>
                            <Tab renderIcon={Person}>Rendimiento por Conductor</Tab>
                        </TabList>
                        <TabPanels>
                            <TabPanel style={{ width: '100%' }}>
                                {(loading_data || loading_adas || loading_perdidas || loading_frenos) ? (
                                    <LoadingContent />
                                ) : (
                                    <Stack gap={3}>
                                        <Button size="sm" renderIcon={UserFollow} onClick={() => {
                                            setIsEditDriverMode(false);          // Modo creación
                                            setIsNewDriverModalOpen(true);       // Abre el modal
                                            setDriverForm({                      // Limpia el formulario
                                                driverId: '',
                                                turn: '',
                                                truck: '',
                                                name: '',
                                                surname: '',
                                                rut: '',
                                                dv: '',
                                                phone: '',
                                                license_number: '',
                                                expiry: '',
                                            });
                                        }}>Añadir llavero</Button>
                                        <Card justifyContent='flex-start' >
                                            <DataTableIcon size={18} />
                                            <Typography className='cds--type-heading-compact-01'>
                                                LLAVEROS
                                            </Typography>
                                        </Card>
                                        <CardRow width='inherit'>
                                            <Card width='100%' padding="0">
                                                <SearchTable
                                                    rows={rows_c}
                                                    headers={headers_c}
                                                    onEditRow={handleEditDriver}
                                                    downloadFileName="conductores.csv"
                                                />
                                            </Card>
                                        </CardRow>
                                    </Stack>
                                )}
                            </TabPanel>
                            <TabPanel style={{ width: '100%' }}>
                                {(loading_data || loading_adas || loading_perdidas || loading_frenos) ? (
                                    <LoadingContent />
                                ) : (
                                    <Stack gap={3}>
                                        <Button size="sm" ref={buttonRef.current} renderIcon={UpdateNow} onClick={() => setOpenLicenseEditModal(true)}>Actualizar Estado de Licencia</Button>
                                        <Card justifyContent='flex-start' >
                                            <DataTableIcon size={18} />
                                            <Typography className='cds--type-heading-compact-01'>
                                                CONDUCTORES - TABLA DE DATOS
                                            </Typography>
                                        </Card>
                                        <CardRow width='inherit'>
                                            <Card width='100%' padding="0">
                                                <ExpansionTable
                                                    hasSearch
                                                    headers={headers}
                                                    rows={rows}
                                                    headerData={headerData}
                                                    detailsFunc={(row) =>
                                                        <Button
                                                            kind="danger--ghost"
                                                            onClick={() => setOpenLicenseUpdateModal(row)}
                                                            renderIcon={Identification}
                                                            style={{ minWidth: "100%" }}
                                                        >
                                                            Ver Ficha de Conductor
                                                        </Button>
                                                    }
                                                />
                                            </Card>
                                        </CardRow>
                                    </Stack>
                                )}
                            </TabPanel>
                            <TabPanel style={{ width: '100%' }}>
                                {(loading_ranking) ? (
                                    <LoadingContent />
                                ) : (
                                    <Stack gap={3}>
                                        <div style={{ width: '20%', padding: 'spacing05' }}>
                                            <ComboBox
                                                id="driverss"
                                                items={items}
                                                itemToString={(item) => (item ? item.label : '')}
                                                placeholder="Seleccionar parámetro de comparación"
                                                titleText="Parámetro de comparación"
                                                selectedItem={selectedItem} // Usa el objeto derivado del estado
                                                onChange={({ selectedItem }) => setSelectedField(selectedItem.value)} // Actualiza el estado
                                            />
                                        </div>
                                        <Card justifyContent='flex-start'>
                                            <DataTableIcon size={18} />
                                            <Typography className='cds--type-heading-compact-01'>
                                                RANKING - TABLA DE CONDUCTORES
                                            </Typography>
                                        </Card>
                                        <div style={{ display: 'flex', width: '100%' }}>
                                            <Card width='100%' justifyContent='flex-start' padding={spacing05}>
                                                <CarbonTableComponent
                                                    headers={[
                                                        "Ranking",
                                                        "Conductor",
                                                        "Horas promedio de todos los turnos",
                                                        "Cantidad de turnos",
                                                        "Horas último turno"
                                                    ]}
                                                    rows={
                                                        [...ranking]
                                                            .sort((a, b) => b[selectedField] - a[selectedField]) // Ordenar de mayor a menor
                                                            .map((data, index) => [
                                                                index + 1,             // Ranking
                                                                data.conductor,        // Conductor
                                                                data[selectedField],
                                                                data.row_count,
                                                                data[selectedField + '_last']
                                                            ])
                                                    }
                                                />
                                            </Card>
                                        </div>
                                    </Stack>
                                )}
                            </TabPanel>
                            <TabPanel style={{ width: '100%' }}>
                                {(loading_adas || loading_perdidas || loading_frenos) ? (
                                    <LoadingContent />
                                ) : (
                                    <Stack gap={3}>
                                        <div style={{ width: '20%', padding: { spacing05 } }}>
                                            <ComboBox
                                                id='driver'
                                                items={driverNames.map(driver => driver.name)}
                                                onChange={({ selectedItem }) => handleDriverChange(selectedItem)}
                                                placeholder='Seleccionar Conductor'
                                                titleText="Conductor"
                                                selectedItem={selectedDriverName}
                                            />
                                            <DatePicker
                                                datePickerType="single"
                                                value={dateValue}
                                                onChange={handleDateChange}
                                                dateFormat="d-m-Y"
                                                locale="es"
                                            // maxDate={maxDateString} // Fecha máxima seleccionable
                                            >
                                                <DatePickerInput id="date-picker-single" placeholder="dd/mm/yyyy" labelText="Fecha de inicio del análisis (Promedio 10 días hacia atrás)" size="md" />
                                            </DatePicker>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                            <Card width='49.5%' justifyContent='flex-start'>
                                                <SummaryKpi size={18} />
                                                <Typography className='cds--type-heading-compact-01'>
                                                    CONTADOR DE ALERTAS - ADAS - CONTROL DE CRUCERO
                                                </Typography>
                                                {/* Aquí puedes agregar más contenido o componentes */}
                                            </Card>
                                            <Card width='49.5%' justifyContent='flex-start'>
                                                <SummaryKpi size={18} />
                                                <Typography className='cds--type-heading-compact-01'>
                                                    CONTADOR DE ALERTAS - ADAS - FATIGA
                                                </Typography>
                                                {/* Aquí puedes agregar más contenido o componentes */}
                                            </Card>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                            <Card width='49.5%' justifyContent='flex-start' padding={spacing05}>
                                                <AlertDashboard alertData={conduccion} />
                                            </Card>
                                            <Card width='49.5%' justifyContent='flex-start' padding={spacing05}>
                                                <AlertDashboard alertData={fatiga} />
                                            </Card>
                                        </div>
                                        <Card justifyContent='flex-start' >
                                            <DataTableIcon size={18} />
                                            <Typography className='cds--type-heading-compact-01'>
                                                RENDIMIENTO - TIEMPOS DEL TURNO
                                            </Typography>
                                        </Card>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                            <Card width='100%' justifyContent='flex-start'>
                                                <SummaryKpi size={18} />
                                                <Typography className='cds--type-heading-compact-01'>
                                                    COMPARACIÓN CON RENDIMIENTO OPTIMO
                                                </Typography>
                                                {/* Aquí puedes agregar más contenido o componentes */}
                                            </Card>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                            <Card width='100%' justifyContent='flex-start' padding={spacing05}>
                                                <CarbonTableComponent
                                                    headers={[
                                                        "",
                                                        "Tiempos de Turno Promedio (horas)",
                                                        "Tiempos de Turno Óptimos (horas)"
                                                    ]}
                                                    rows={
                                                        tableRows.map((row) => [
                                                            row.name,
                                                            row.status, // Corresponde a la primera columna
                                                            row.example   // Corresponde a la segunda columna
                                                        ])
                                                    }
                                                />
                                            </Card>
                                        </div>
                                        <Card justifyContent='flex-start' >
                                            <ChartColumn size={18} />
                                            <Typography className='cds--type-heading-compact-01'>
                                                EVOLUCIÓN DEL RENDIMIENTO - TIEMPOS DEL TURNO - 7 DÍAS
                                            </Typography>
                                        </Card>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                            <Card width='100%' justifyContent='flex-start' padding={spacing05}>
                                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                                    <div style={{ width: '20%', paddingBottom: spacing05 }}>
                                                        <ComboBox
                                                            id="tiempo"
                                                            items={items.map(item => item.label)} // Mostrar los labels en el ComboBox
                                                            onChange={({ selectedItem }) => {
                                                                const selected = items.find(item => item.label === selectedItem);
                                                                setSelectedOption(selected); // Actualizar la opción seleccionada
                                                            }}
                                                            placeholder="Tiempo a analizar"
                                                            titleText="Seleccionar tiempo del turno"
                                                        />
                                                    </div>
                                                    <LineChartComponent
                                                        chartData={perdidasSemana}  // Pasar los datos al gráfico
                                                        chartTitle={selectedOption.label}  // Pasar el título como prop
                                                    />
                                                </div>
                                            </Card>
                                        </div>
                                        <Card justifyContent='flex-start' >
                                            <DataTableIcon size={18} />
                                            <Typography className='cds--type-heading-compact-01'>
                                                RENDIMIENTO - CONDUCCIÓN
                                            </Typography>
                                        </Card>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                            <Card width='100%' justifyContent='flex-start'>
                                                <SummaryKpi size={18} />
                                                <Typography className='cds--type-heading-compact-01'>
                                                    PROMEDIOS
                                                </Typography>
                                                {/* Aquí puedes agregar más contenido o componentes */}
                                            </Card>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                            <Card width='100%' justifyContent='flex-start' padding={spacing05}>
                                                <CarbonTableComponent
                                                    headers={[
                                                        "",
                                                        "Cantidad",
                                                        "Promedio Rendimiento Optimo"
                                                    ]}
                                                    rows={tableRows_2.map((row) => [
                                                        row.name,
                                                        row.status, // Corresponde a la primera columna
                                                        row.example   // Corresponde a la segunda columna
                                                    ])} // Pasar las filas como parámetro
                                                />
                                            </Card>
                                        </div>
                                        <Card justifyContent='flex-start' >
                                            <SummaryKpi size={18} />
                                            <Typography className='cds--type-heading-compact-01'>
                                                EVOLUCIÓN RENDIMIENTO - CONDUCCIÓN - 7 DÍAS
                                            </Typography>
                                        </Card>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                            <Card width='100%' justifyContent='flex-start' padding={spacing05}>
                                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                                    <div style={{ width: '20%', paddingBottom: spacing05 }}>
                                                        <ComboBox
                                                            id='conducir'
                                                            items={items_2.map(item => item.label)} // Mostrar los labels en el ComboBox
                                                            onChange={({ selectedItem }) => {
                                                                const selected = items_2.find(item => item.label === selectedItem);
                                                                setSelectedOption_2(selected); // Actualizar la opción seleccionada
                                                            }}
                                                            placeholder='Aspecto a analizar'
                                                            titleText="Seleccionar aspecto de la conducción"
                                                        />
                                                    </div>
                                                    <LineChartComponent
                                                        chartData={frenosSemana}  // Pasar los datos al gráfico
                                                        chartTitle={selectedOption_2.label}  // Pasar el título como prop
                                                    />
                                                </div>
                                            </Card>
                                        </div>
                                    </Stack>
                                )}
                            </TabPanel>
                        </TabPanels>
                    </Tabs>
                    <LicenseEditModal open={openLicenseEditModal} setOpen={setOpenLicenseEditModal} ref={buttonRef.current} />
                    <LicenseUpdateModal open={openLicenseUpdateModal} setOpen={setOpenLicenseUpdateModal} ref={buttonUpdateRef.current} />
                    <Modal
                        open={isNewDriverModalOpen}
                        modalHeading={isEditDriverMode ? "Editar Llavero" : "Añadir Llavero"}
                        primaryButtonText={isEditDriverMode ? "Guardar Cambios" : "Añadir Llavero"}
                        secondaryButtonText="Cancelar"
                        onRequestClose={() => {
                            setIsNewDriverModalOpen(false);
                            setIsEditDriverMode(false);
                            setSelectedDriverData(null);
                        }}
                        onRequestSubmit={handleSubmitDriver}
                        size="lg" // puedes usar 'lg' para que se vea más amplio
                    >
                        {/* Formulario de la imagen */}
                        <p>
                            {isEditDriverMode
                                ? "Formulario para editar los datos asociados a un llavero."
                                : "Este es un formulario para añadir un conductor a la tabla de registro de conductores. Este formulario solo funciona con conductores nuevos de forma individual."}
                        </p>
                        {isEditDriverMode && (
                            <div style={{
                                border: '1px solid #3D70B2',
                                borderRadius: '0.5rem',
                                padding: '1rem',
                                marginTop: '1rem'
                            }}>
                                <strong>Las llaves no pueden ser modificadas.</strong>
                                <p style={{ marginTop: '0.5rem' }}>
                                    Si cometió un error de tipeo al ingresar una llave, debe crear un nuevo registro.
                                </p>
                            </div>
                        )}
                        <div style={{ display: 'flex', gap: '2rem', marginTop: '1rem' }}>
                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                                <TextInput id="driverId" labelText="Llave iButton" defaultValue={driverForm.driverId} ref={formRefs.driverId} readOnly={isEditDriverMode} />
                                <TextInput id="name" labelText="Nombres" defaultValue={driverForm.name} ref={formRefs.name} />
                                <TextInput id="surname" labelText="Apellidos" defaultValue={driverForm.surname} ref={formRefs.surname} />
                            </div>

                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                                <TextInput id="rut" labelText="Rut" defaultValue={driverForm.rut} ref={formRefs.rut} />
                                <TextInput id="dv" labelText="Dígito verificador" defaultValue={driverForm.dv} ref={formRefs.dv} />
                            </div>
                        </div>
                    </Modal>
                    <Modal
                        open={openLlaveroModal}
                        onRequestClose={() => setOpenLlaveroModal(false)}
                        modalHeading="Como gestionar los llaveros"
                        size="sm"
                        passiveModal
                    >
                        <div style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <p style={{ margin: 0 }}>
                                Acá puede encontrar toda la información relevante de como gestionar los llaveros en distintos casos de uso.
                            </p>
                        </div>

                        <Accordion align="start">
                            <AccordionItem title="¿Cómo añadir un nuevo conductor con su llavero correspondiente?">
                                <p style={{ marginBottom: '1rem' }}>
                                    Para añadir un conductor en la plataforma, es importante contar con la información del conductor y tener a mano el nuevo llavero,
                                    ya que ambos datos son necesarios para completar el formulario de ‘Añadir Conductor’. Este llavero se encuentra en la primera pestaña
                                    ‘Gestón de Conductores y Llaveros’ junto al botón de esta documentación. En caso de estar reutilizando un llavero antiguo, la información del
                                    conductor antiguo será reemplazada por la del conductor nuevo.
                                </p>

                                <img
                                    src="/assets/images/Ubicacion_Formulario_1.png"
                                    alt="Botón para añadir conductor"
                                    style={{ width: '100%', borderRadius: '8px', marginBottom: '1rem' }}
                                />

                                <p style={{ marginBottom: '1rem' }}>
                                    El formulario de registro requiere obligatoriamente la siguiente información:
                                    iButton, nombres, apellidos, RUT (sin dígito verificador), dígito verificador,
                                    número de celular, número de licencia, turno asignado y tipo de equipo.
                                    Con la información ingresada y validada por el usuario, solo es necesario
                                    presionar ‘Añadir Conductor’ para incluirlo en la base de datos.
                                </p>

                                <img
                                    src="/assets/images/image_13.png"
                                    alt="Formulario añadir conductor"
                                    style={{ width: '100%', borderRadius: '8px', marginBottom: '1rem' }}
                                />

                                <p>
                                    La plataforma puede demorar unos minutos en mostrar el cambio para los conductores en los equipos del mapa,
                                    pero este cambio es instantáneo para la tabla de conductores y llaveros.
                                </p>
                            </AccordionItem>
                            <AccordionItem title="¿Cómo editar el llavero de un conductor?">
                                <p style={{ marginBottom: '1rem' }}>
                                    La plataforma permite modificar el llavero principal del conductor y el registro de llaveros anteriores.
                                    Para modificar el llavero de un conductor se debe utilizar el modal ‘Editar Conductor’ que se encuentra disponible
                                    al final de las columnas de la tabla de Conductores Registrados.
                                </p>

                                <p style={{ marginBottom: '1rem' }}>
                                    Si deseas buscar a un conductor en particular, puede utilizar la barra de búsqueda ubicada en la parte superior
                                    derecha de la tabla. Tenga en cuenta que esta búsqueda se puede realizar por llave iButton, nombre, apellido, turno, equipo.
                                </p>

                                <img
                                    src="/assets/images/Ubicación_Formulario_Editar_1.png"
                                    alt="Tabla con opción de editar conductor"
                                    style={{ width: '100%', borderRadius: '8px', marginBottom: '1rem' }}
                                />

                                <p style={{ marginBottom: '1rem' }}>
                                    Este formulario es similar al de ‘Añadir Conductor’, pero permite gestionar el detalle de los llaveros.
                                    Una vez realizadas las modificaciones, verifique la información ingresada y haga clic en ‘Guardar Cambios’
                                    para actualizar los datos del conductor.
                                </p>

                                <img
                                    src="/assets/images/Guardar_Cambios_1.png"
                                    alt="Formulario de edición de conductor"
                                    style={{ width: '100%', borderRadius: '8px', marginBottom: '1rem' }}
                                />

                                <p style={{ marginBottom: '1rem' }}>
                                    <strong>¿Cómo asignar un nuevo llavero si el conductor perdió el anterior?</strong><br />
                                    En caso de perder un llavero iButton, el nuevo iButton debe ser asignado al campo Llave iButton. El iButton anterior (perdido) debe moverse al campo Llave iButton (2).Si Llave iButton (2) ya está ocupada, su valor debe desplazarse a Llave iButton (3), y luego asignar el  iButton perdido a Llave iButton (2).Este proceso se repite de forma secuencial, preservando el historial de llaveros utilizados por el conductor
                                </p>

                                <p style={{ marginBottom: '1rem' }}>
                                    <strong>¿Cómo volver a asignar un llavero antiguo?</strong><br />
                                    En caso de necesitar volver a asignarle un llavero antiguo a el conductor, simplemente tiene que subir el llavero antiguo
                                    al campo primario (Llave iButton) y dejar el llavero que ya no va a utilizar en un campo de llavero antiguo.
                                </p>

                                <p>
                                    La plataforma puede demorar unos minutos en mostrar el cambio para los conductores en los equipos del mapa,
                                    pero este cambio es instantáneo para la tabla de conductores y llaveros.
                                </p>
                            </AccordionItem>
                            <AccordionItem title="¿Cómo actualizar un llavero ‘Sin Registro’ que aparece en el mapa?">
                                <p style={{ marginBottom: '1rem' }}>
                                    Para actualizar un llavero ‘Sin Registro’, es necesario primero ver si este llavero se encuentra asignado a algún conductor,
                                    ya sea como un llavero usado anteriormente o como un llavero de un conductor NO ACTIVO. <br />
                                    Esto lo podemos hacer buscando el llavero que aparece en el mapa en tiempo real con el buscador dentro de la tabla.
                                </p>

                                <img
                                    src="/assets/images/image_17.png"
                                    alt="Llavero sin registro y cómo buscarlo"
                                    style={{ width: '100%', borderRadius: '8px', marginBottom: '1rem' }}
                                />

                                <p style={{ marginBottom: '1rem' }}>"Una vez verificado que el llavero y el conductor no existen en la tabla, se puede proceder a registrarlos en la plataforma
                                    utilizando un llavero no asignado y los datos del conductor, siguiendo el procedimiento descrito en el primer punto
                                    ‘¿Cómo añadir un nuevo conductor con su llavero correspondiente?’."</p>
                            </AccordionItem>
                            <AccordionItem title="¿Cómo puedo dar de baja un llavero o conductor?">
                                <p style={{ marginBottom: '1rem' }}>
                                    Por razones de auditoría e integridad de datos, los conductores no se eliminan permanentemente.
                                    En su lugar, se marcan como inactivos. Esto es a través de la fecha de vencimiento, esta es manejable
                                    en la pestaña ‘Gestión de licencias’.
                                </p>

                                <p style={{ marginBottom: '1rem' }}>
                                    En un mismo sentido los llaveros tampoco son eliminados y solamente son asignados a distintos conductores en la plataforma,
                                    o quedan en el registro de llaveros antiguos si es que se le entrega uno nuevo a un conductor.
                                </p>

                                <img
                                    src="/assets/images/image_19.png"
                                    alt="Pantalla de baja de conductor o llavero"
                                    style={{ width: '100%', borderRadius: '8px', marginBottom: '1rem' }}
                                />
                            </AccordionItem>
                        </Accordion>
                    </Modal>
                </>
            )}
        </>
    )
};

export default DriverContainer;
